import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, catchError, map, of } from 'rxjs';
import * as InAppNotificationPreferencesActions from 'src/app/in-app-notifications/store/actions/in-app-notification-preferences.actions';
import { HttpResponseHelpers } from 'src/app/shared/helpers';
import { showToasterMessage } from 'src/app/shared/actions/toaster.actions';
import { InAppNotificationPreferencesService } from 'src/app/in-app-notifications/in-app-notification-preferences.service';

@Injectable()
export class InAppNotificationPreferencesEffects {
    constructor(private readonly _actions$: Actions, private readonly _service: InAppNotificationPreferencesService) {}

    getInAppNotificationPreferences$ = createEffect(() =>
        this._actions$.pipe(
            ofType(
                InAppNotificationPreferencesActions.getInAppNotificationPreferences,
                InAppNotificationPreferencesActions.updateInAppNotificationPreferenceSuccess
            ),
            switchMap(() => {
                return this._service.getInAppNotificationPreferences().pipe(
                    map((result) =>
                        InAppNotificationPreferencesActions.getInAppNotificationPreferencesSuccess({
                            inAppNotificationPreferences: result
                        })
                    ),
                    catchError((error) =>
                        of(
                            InAppNotificationPreferencesActions.getInAppNotificationPreferencesFailure({
                                error: HttpResponseHelpers.parseErrorResponse(error)
                            })
                        )
                    )
                );
            })
        )
    );

    updateInAppNotificationPreference$ = createEffect(() =>
        this._actions$.pipe(
            ofType(InAppNotificationPreferencesActions.updateInAppNotificationPreference),
            switchMap((action) => {
                return this._service.updateInAppNotificationPreference(action.preferenceId, action.isEnabled).pipe(
                    map(() =>
                        InAppNotificationPreferencesActions.updateInAppNotificationPreferenceSuccess({
                            message: 'Preference updated successfully'
                        })
                    ),
                    catchError((error) =>
                        of(
                            InAppNotificationPreferencesActions.updateInAppNotificationPreferenceFailure({
                                error: HttpResponseHelpers.parseErrorResponse(error)
                            })
                        )
                    )
                );
            })
        )
    );

    inAppNotificationPreferenceSuccessToaster$ = createEffect(() =>
        this._actions$.pipe(
            ofType(InAppNotificationPreferencesActions.updateInAppNotificationPreferenceSuccess),
            map((action) => showToasterMessage({ message: action.message }))
        )
    );

    inAppNotificationPreferenceFailureToaster$ = createEffect(() =>
        this._actions$.pipe(
            ofType(
                InAppNotificationPreferencesActions.getInAppNotificationPreferencesFailure,
                InAppNotificationPreferencesActions.updateInAppNotificationPreferenceFailure
            ),
            map((action) => showToasterMessage({ message: action.error }))
        )
    );
}
